$(function(){
	if( $('.thinq-section').length == 0 ) return;
	var $thinq = $('.thinq-section');

	var $pressList = $thinq.find('.press-list');
	var $pressArticle = $pressList.find('.article');
	var $pressMore = $thinq.find('.press-more');

	var $mediaList = $thinq.find('.media-list');
	var $mediaArticle = $mediaList.find('.article');
	var $mediaMore = $thinq.find('.media-more');

	var pressPage = 9;
	var mediaPage = 5;

	/*
	 * Sticky Menu
	 */
	 function stickyMenu() {
 		var $stickyArea = $thinq.find('.sticky-menu');
 		var $stickyLink = $stickyArea.find('.menu-list');
		var $stickyInner = $stickyArea.find('.sticky-inner');
 		var stickyHeight;
 		var stickyUpperHeight;
 		var activeLineWidth;

 		function stickyResizeSet(){
 			stickyHeight = $stickyArea.height();
 			var naviHeight = $('.navigation').height();
 			var breadcrumbHeight = $('.breadcrumb').height();


 			if(window.innerWidth >= 768) {
 				$('body').removeClass('isMobile');
 				stickyUpperHeight = naviHeight + breadcrumbHeight;
 			} else {
 				$('body').addClass('isMobile');
 				stickyUpperHeight = naviHeight;

 			}
 			// sticky fixed reset
 			if( $(window).scrollTop() >= stickyUpperHeight ){
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
					setTimeout(function(){
	          $stickyInner.find('.arrow').addClass('js-fade');
	        },3000);
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

		function mobileActiveScroll(){
			$stickyArea.find('ul').each(function (){
	  	var _width = $(this).width(),
	    		_length = $(this).length,
	        _index = $(this).find('.active').index();
	    $stickyLink.scrollLeft((_width/_length) * _index);
			});
		}

 		function stickyScrollSet(){
 			var windowTop = $(window).scrollTop();
			mobileActiveScroll();
 			if(windowTop >= stickyUpperHeight){
 				// sticky fixed
 				if(!$stickyArea.hasClass('fixed')){
 					$stickyArea.addClass('fixed');
					mobileActiveScroll();
					setTimeout(function(){
	          $stickyInner.find('.arrow').addClass('js-fade');
	        },3000);
 				}
 			} else {
 				if($stickyArea.hasClass('fixed')){
 					$stickyArea.removeClass('fixed');
 				}
 			}
 		}

		// Product Tab Scroll Design
		function mScrollCheck(){
			if( $('body').hasClass('no-touch') ){
				$stickyInner.find('.menu-list').mCustomScrollbar({
					theme:'dark',
					mouseWheelPixels:300,
					axis:'x'
				});
			} else {
				$stickyInner.append('<div class="arrow"></div>');
				$stickyInner.on('touchend', function(){
					$stickyInner.find('.arrow').addClass('js-fade');
				});
			}
		}

		mScrollCheck();
 		$(window).on('resize.stickyResizeSet', stickyResizeSet).trigger('resize.stickyResizeSet');
 		$(window).on('scroll.stickyScrollSet', stickyScrollSet).trigger('scroll.stickyScrollSet');

 	}

	/*
	 * Magazine Tab
	 */
	var contents = getUrlParams(['contents']);
	var $tabList = $thinq.find('.magazine-tab');
	var $tabContent = $thinq.find('.magazine-content');
	// var openTitle = $tabList.find('.title').data('title-open');
	// var closeTitle = $tabList.find('.title').data('title-close');

	if ( !$('.magazine-tab').hasClass('complete') ){
		setTimeout(function(){
			$('.magazine-tab').addClass('complete');
		}, 100);
	}

	function magazineTabActive(e){
		e.preventDefault();

		var $self = $(this);
		var targetId = $self.attr('href');
		//var targetTxt = $self.text();

		if( $tabList.hasClass('selected') ){
			$tabList.removeClass('selected');
		}
		//$tabList.find('.title').attr('aria-label', openTitle).text(targetTxt);

		$tabList.find('li').removeClass('active').find('a').attr('aria-selected', 'false');
		$self.attr('aria-selected', 'true').parent('li').addClass('active');
		$tabContent.removeClass('active');
		$(targetId).addClass('active');

		magazineInteraction();
	}
	$tabList.find('li a').on('click', magazineTabActive);

	function getUrlParams( prop ) {
		var params = {};
		var search = decodeURIComponent( window.location.href.slice( window.location.href.indexOf( '?' ) + 1 ) );
		var definitions = search.split( '&' );

		definitions.forEach( function( val, key ) {
			var parts = val.split( '=', 2 );
			params[ parts[ 0 ] ] = parts[ 1 ];
		} );

		return ( prop && prop in params ) ? params[ prop ] : params;
	}
	function tabInit(num) {
		$('.magazine-tab ul li').eq(num).find('a').trigger('click');
		history.replaceState({}, null, location.pathname);
	}

	switch (contents) {
		case 'news' :
			tabInit(0)
			break;
		case 'media' :
			tabInit(1)
			break;
	}

	/*
	 * Press Count
	 */
	var $pressCount = $thinq.find('.press-count');
	$pressCount.find('strong').html($pressArticle.length);
	setTimeout(function(){
		$pressCount.addClass('complete');
	}, 100);

	/*
	 * Magazine Load More
	 */
	function pressLoadMore(){
		$pressArticle.each(function(idx){
			if( idx > pressPage-1 ){
				$(this).addClass('hidden');
			}
		});

		var count = 1;
		var total = $pressArticle.length;
		var pressCount = parseInt(total/pressPage);
		var etcCount = total % pressPage;

		if(total <= pressPage){
			$pressMore.css('display','none');
		}

		if(etcCount>0){
			pressCount = pressCount+1;
		}

		var last = 0;
		if(count >= pressCount){
			last = etcCount;
		} else {
			last = pressPage;
		}

		$pressMore.find('.btn-more').on('click',function(e){
			e.preventDefault();

			for(var i=count*pressPage; i<count*pressPage+last; i++){
				$pressArticle.eq(i).removeClass('hidden');
			}
			$pressArticle.eq(count*pressPage).find('a').focus();

			count++;
			if(count >= pressCount){
				$pressMore.css('display','none');
			}

			magazineInteraction();
		});
	}

	function mediaLoadMore(){
		$mediaArticle.each(function(idx){
			if( idx > mediaPage-1 ){
				$(this).addClass('hidden');
			}
		});

		var count = 1;
		var total = $mediaArticle.length;
		var mediaCount = parseInt(total/mediaPage);
		var etcCount = total % mediaPage;

		if(total <= mediaPage){
			$mediaMore.css('display','none');
		}

		if(etcCount>0){
			mediaCount = mediaCount+1;
		}

		var last = 0;
		if(count >= mediaCount){
			last = etcCount;
		} else {
			last = mediaPage;
		}

		$mediaMore.find('.btn-more').on('click',function(e){
			e.preventDefault();

			for(var i=count*mediaPage; i<count*mediaPage+last; i++){
				$mediaArticle.eq(i).removeClass('hidden');
			}
			$mediaArticle.eq(count*mediaPage).find('a').focus();

			count++;
			if(count >= mediaCount){
				$mediaMore.css('display','none');
			}

			magazineInteraction();
		});
	}

	/*
	 * Magazine Interaction
	 */
	function magazineInteraction() {
		var scrollTop = $(window).scrollTop();
		var scrollBottom = $(window).scrollTop() + $(window).height();
		var delayTime = 0;

		$pressArticle.each(function() {
			var $self = $(this);
			var current = $self.offset().top;

			if(!$self.hasClass('animated') && !$self.hasClass('hidden')) {
				if( current > scrollTop && current <= scrollBottom  ) {
					delayTime += 300;

					setTimeout(function() {
						$self.addClass('animated');
					}, delayTime);
				}
			}
		});
		$mediaArticle.each(function() {
			var $self = $(this);
			var current = $self.offset().top;

			if(!$self.hasClass('animated') && !$self.hasClass('hidden')) {
				if( current > scrollTop && current <= scrollBottom  ) {
					delayTime += 300;

					setTimeout(function() {
						$self.addClass('animated');
					}, delayTime);
				}
			}
		});
	}

	/*
	 * Press Detail Slide
	 */
	function magazineDetailSlide(){
		// var $pressSlide = $thinq.find('.press-detail .slide-area');
		// $pressSlide.each(function(){
		// 	$(this).slick({
		// 		dots: true,
		// 		infinite: false,
		// 		arrows: true,
		// 		prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
		// 		nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>'
		// 	});
		// });

		var $videoSlide = $thinq.find('.video-slide-block .text-slide');
		var $playArea = $thinq.find('.press-detail .play-area');
		$videoSlide.each(function(){
			$(this).slick({
				dots: true,
				infinite: false,
				arrows: true,
				prevArrow: '<button class="slick-prev slick-arrow" type="button">Previous</button>',
				nextArrow: '<button class="slick-next slick-arrow" type="button">Next</button>'
			});
		});
		$videoSlide.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$playArea.find('.list > li').removeClass('active').eq(nextSlide).addClass('active');
		});
	}

	/*
	* Press Detai Interaction
	*/
	function pressDetailInteraction() {
		var $obj = $('.animate-target');
		$obj.each(function() {
			if( !$(this).hasClass('animated') ) {
				var t = $(this).offset().top;
				var b = $(this).offset().top + $(this).outerHeight();
				if(isInScreen(t, b)) {
					var delayTimer = parseInt($(this).attr('data-delay'));
					$(this).delay(delayTimer).queue(function(){$(this).addClass('animated')});
				}
			}
		});
	}


	stickyMenu();
	pressLoadMore();
	mediaLoadMore();
	$(window).on('scroll.magazineInteraction', magazineInteraction).trigger('scroll.magazineInteraction');

	magazineDetailSlide();
	$(window).on('scroll.pressDetailInteraction', pressDetailInteraction).trigger('scroll.pressDetailInteraction');
});
